module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.serviceTypes.length === 1) ? _c('div', [_c(_vm.serviceTypes[0], {
    tag: "component",
    on: {
      "form-state": _vm.setServiceValidity,
      "form-invalid": function($event) {
        return _vm.setServiceValidity(false)
      },
      "form-valid": function($event) {
        return _vm.setServiceValidity(true)
      }
    }
  })], 1) : _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502602e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/AddServices.vue
// module id = 1325
// module chunks = 16